import { Button } from '@breetometer/components';
import { ArrowIcon, ConvertIcon, PlusIcon } from 'BreetAssets';
import { useModalApi } from 'BreetHooks';

export const HeaderCTA = () => {
	const { handleOpenModal } = useModalApi();

	return (
		<div className='home-header-cta'>
			<Button
				trailingIcon={<PlusIcon />}
				className='fund'
				onClick={handleOpenModal({ id: 'fundWallet', variant: 'right-sheet' })}
			>
				Fund Wallet
			</Button>
			<Button
				trailingIcon={<ArrowIcon variant='arrowDown' />}
				className='withdraw'
				onClick={handleOpenModal({ id: 'requestPayment', variant: 'right-sheet' })}
			>
				Withdraw
			</Button>
			<Button
				trailingIcon={<ConvertIcon />}
				className='convert'
				onClick={handleOpenModal({ id: 'convertCurrency', variant: 'right-sheet' })}
			>
				Convert
			</Button>
		</div>
	);
};
